'use client'

import { useEffect, useState } from 'react'

/**
 * Client hook: fetch site_content rows for a section, ordered by sort_order.
 *
 * @param {string} section - required section key
 * @returns {{ items: Array, loading: boolean, error: string|null }}
 */
export function useSiteContent(section) {
  const [items, setItems] = useState([])
  // Initial loading depends on whether we have a section to fetch.
  // Avoids synchronous setState inside the effect body (react-hooks/set-state-in-effect).
  const [loading, setLoading] = useState(!!section)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!section) return
    let cancelled = false
    fetch(`/api/site-content?section=${encodeURIComponent(section)}`)
      .then(r => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`)
        return r.json()
      })
      .then(arr => {
        if (cancelled) return
        setItems(Array.isArray(arr) ? arr : [])
      })
      .catch(e => { if (!cancelled) setError(e.message) })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [section])

  return { items, loading, error }
}
